import { ReactNode } from 'react';

import { IconButton, IconButtonProps } from '@mui/material';

type HeaderIconButtonProps = IconButtonProps & {
    children: ReactNode;
    component?: IconButtonProps['component'];
    to?: string;
};

export function HeaderIconButton({ children, sx, ...props }: HeaderIconButtonProps) {
    return (
        <IconButton
            {...props}
            sx={{
                'height': 40,
                'maxWidth': 40,
                'minWidth': 40,
                'border': 1,
                'borderRadius': 1.5,
                'borderColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.2),
                'backgroundColor': (theme) => theme.lighten(theme.palette.secondary.main, 0.075),
                'color': 'common.white',
                '&:hover': {
                    borderColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.3),
                    backgroundColor: (theme) => theme.lighten(theme.palette.secondary.main, 0.15),
                    color: 'common.white',
                },
                ...sx,
            }}
        >
            {children}
        </IconButton>
    );
}
